// extracted by mini-css-extract-plugin
export default {"productCarousel":"Gk","twoColumns":"Hk","subhed":"Ik","promo":"Jk","questionIcon":"Kk","thumbContainer":"Lk","carousel":"Mk","tape":"Nk","flexContainer":"Ok","nav":"Pk","body":"Qk","reviews":"Rk","header":"Sk","hed":"Tk","priceContainer":"Uk","oldPrice":"Vk","newPrice":"Wk","infoTabs":"Xk","tabs":"Yk","text":"Zk","questionWrapper":"al","isQuantity":"bl","title":"cl","titleRight":"el","addToCart":"fl","servingsPerItem":"gl","quantityInput":"hl","quantityButton":"il","takeTheQuiz":"jl"};
    if(module.hot) {
      // 1713912562505
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  